/**
 * Dropdown Menu Initialization
 * Initializes dropdown menus for posts and comments on page load
 */

import { translator } from "../../translation/translator";
import { dropdownRender } from "./dropdown-render";
import { dropdownForm } from "./dropdown-form";
import { toPositiveIntOrNull } from "../id-utils";

export function initializeDropdownMenus(): void {
    const postContainers = dropdownForm.getPostDropdownContainers();
    postContainers.forEach((container) => {
        if (!(container instanceof HTMLElement)) {
            return;
        }
        const postId = toPositiveIntOrNull(container.dataset.postId);
        const userId = toPositiveIntOrNull(container.dataset.userId);
        if (postId && dropdownRender) {
            const dropdownHtml = dropdownRender.generatePostDropdownMenu({
                post_id: postId,
                id: postId,
                user_id: userId,
            });
            container.innerHTML = dropdownHtml;
        }
    });

    const commentContainers = dropdownForm.getCommentDropdownContainers();
    commentContainers.forEach((container) => {
        if (!(container instanceof HTMLElement)) {
            return;
        }
        const commentId = toPositiveIntOrNull(container.dataset.commentId);
        const userId = toPositiveIntOrNull(container.dataset.userId);
        if (commentId && dropdownRender) {
            const dropdownHtml = dropdownRender.generateCommentDropdownMenu({
                comment_id: commentId,
                id: commentId,
                user_id: userId,
            });
            container.innerHTML = dropdownHtml;
        }
    });

    translator.updateContent();
}
